import { css } from '@emotion/css'

export const PiProfileSectionClass = () => css`
  display: flex;
  justify-content: center;
  align-items: center;
  .down-arrow{
    margin-left: 5px;
  }
  .arrowClass {
    svg {
      margin-left: 5px;
    }
  }
`
